import { create } from 'zustand';

type PlantMode = 'single' | 'field';

const key = (mode: PlantMode) => `pro-plant:${mode}`;

function read(mode: PlantMode): string | null {
	if (typeof window === 'undefined') return null;
	return localStorage.getItem(key(mode));
}

interface PlantStore {
	selected: Record<PlantMode, string | null>;
	select: (mode: PlantMode, id: string) => void;
}

/** Plant selected in the header for each dashboard mode, persisted per mode. */
export const usePlantStore = create<PlantStore>((set) => ({
	selected: { single: read('single'), field: read('field') },
	select: (mode, id) => {
		localStorage.setItem(key(mode), id);
		set((s) => ({ selected: { ...s.selected, [mode]: id } }));
	},
}));
